import * as types from './types';

export const networkOn = () => ({
    type: types.NETWORK_ONLINE,
});

export const networkOff = () => ({
    type: types.NETWORK_OFFLINE,
});
